export default __webpack_public_path__ + "static/media/nocturne.235d3552.png";